(() => {
  const rootSelector = '[data-arb-projects-grid]';
  const triggerSelector = '[data-arb-project-video-trigger]';

  function initBasicFilterSetupMultiMatch(scope = document) {
    const transitionDelay = 300;
    const groups = [...scope.querySelectorAll('[data-filter-group]')];

    groups.forEach((group) => {
      if (group.dataset.filterGroupReady === 'true') return;
      group.dataset.filterGroupReady = 'true';

      const buttons = [...group.querySelectorAll('[data-filter-target]')];
      const items = [...group.querySelectorAll('[data-filter-name]')];

      items.forEach((item) => {
        const cs = item.querySelectorAll('[data-filter-name-collect]');
        if (!cs.length) return;
        const seen = new Set();
        const out = [];
        cs.forEach((c) => {
          const v = (c.getAttribute('data-filter-name-collect') || '').trim().toLowerCase();
          if (v && !seen.has(v)) {
            seen.add(v);
            out.push(v);
          }
        });
        if (out.length) item.setAttribute('data-filter-name', out.join(' '));
      });

      const itemTokens = new Map();
      items.forEach((el) => {
        const tokens = (el.getAttribute('data-filter-name') || '')
          .trim()
          .toLowerCase()
          .split(/\s+/)
          .filter(Boolean);
        itemTokens.set(el, new Set(tokens));
      });

      const setItemState = (el, on) => {
        const next = on ? 'active' : 'not-active';
        if (el.getAttribute('data-filter-status') !== next) {
          el.setAttribute('data-filter-status', next);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
        }
      };
      const setButtonState = (btn, on) => {
        const next = on ? 'active' : 'not-active';
        if (btn.getAttribute('data-filter-status') !== next) {
          btn.setAttribute('data-filter-status', next);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.classList.toggle('is-active', on);
        }
      };

      let activeTarget = null;
      const itemMatches = (el) => {
        if (!activeTarget || activeTarget === 'all') return true;
        return itemTokens.get(el).has(activeTarget);
      };

      const paint = (rawTarget) => {
        const target = (rawTarget || '').trim().toLowerCase();
        activeTarget = !target || target === 'all' ? 'all' : target;

        items.forEach((el) => {
          if (el._ft) clearTimeout(el._ft);
          const next = itemMatches(el);
          const cur = el.getAttribute('data-filter-status');
          if (cur === 'active' && transitionDelay > 0) {
            el.setAttribute('data-filter-status', 'transition-out');
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else if (transitionDelay > 0) {
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else {
            setItemState(el, next);
          }
        });

        buttons.forEach((btn) => {
          const t = (btn.getAttribute('data-filter-target') || '').trim().toLowerCase();
          setButtonState(btn, (activeTarget === 'all' && t === 'all') || (t && t === activeTarget));
        });
      };

      group.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-filter-target]');
        if (btn && group.contains(btn)) paint(btn.getAttribute('data-filter-target'));
      });
    });
  }

  function getYouTubeEmbed(videoId) {
    return videoId ? `https://www.youtube.com/embed/${encodeURIComponent(videoId)}` : '';
  }

  function normalizeEmbedSrc(rawSrc, youtubeId, provider) {
    if (youtubeId) return getYouTubeEmbed(youtubeId);
    if (!rawSrc) return '';

    try {
      const url = new URL(rawSrc, window.location.href);
      const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
      const normalizedProvider = (provider || '').toLowerCase();

      if (hostname === 'youtu.be') {
        return getYouTubeEmbed(url.pathname.split('/').filter(Boolean)[0]);
      }

      if (hostname === 'youtube.com' || hostname === 'm.youtube.com' || normalizedProvider === 'youtube') {
        const videoId = url.searchParams.get('v');
        if (videoId) return getYouTubeEmbed(videoId);

        const embedMatch = url.pathname.match(/^\/embed\/([^/]+)/);
        if (embedMatch) return getYouTubeEmbed(embedMatch[1]);

        const shortsMatch = url.pathname.match(/^\/shorts\/([^/]+)/);
        if (shortsMatch) return getYouTubeEmbed(shortsMatch[1]);
      }

      if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com' || normalizedProvider === 'vimeo') {
        const videoId = url.pathname.split('/').filter(Boolean).pop();
        if (videoId) return `https://player.vimeo.com/video/${encodeURIComponent(videoId)}`;
      }
    } catch (error) {
      return rawSrc;
    }

    return rawSrc;
  }


  /* WCAG 2.1.2 / 4.1.2 (FAIL-A2): the modal declares role="dialog"
     aria-modal="true", so Tab and Shift+Tab must cycle INSIDE it. Measured before
     this: the third Tab off the close button landed on a project card on the page
     behind the scrim — content the modal had already told a screen reader was
     inert. Lifted from assets/arb-product-gallery.js (L247-L271), which probe (k)
     verifies on both PDPs. One deliberate difference: `iframe` is in the selector
     here. The YouTube player is a real tab stop in this dialog and it is the only
     route to the provider's pause control, so leaving it out would cycle Tab over
     the two close buttons and make pause unreachable — a 2.2.2 defect introduced
     while fixing 2.1.2. The two video modals must stay identical to each other. */
  var MODAL_FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function trapModalTab(root, event) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(MODAL_FOCUSABLE)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !root.contains(active)) {
        event.preventDefault();
        last.focus();
      }
      return;
    }

    if (active === last || !root.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }

  function initProjectsGrid(root) {
    if (!root || root.dataset.arbProjectsGridReady === 'true') return;
    root.dataset.arbProjectsGridReady = 'true';

    const modal = root.querySelector('[data-arb-project-video-modal]');
    const iframe = root.querySelector('[data-arb-project-video-iframe]');
    const title = root.querySelector('[data-arb-project-video-title]');
    let lastTrigger = null;

    if (!modal || !iframe || !title) return;

    const closeButtons = root.querySelectorAll('[data-arb-project-video-close]');

    function closeModal() {
      iframe.src = '';
      iframe.title = '';
      title.textContent = '';
      modal.hidden = true;
      document.body.classList.remove('arb-project-video-modal-open');

      if (lastTrigger instanceof HTMLElement) {
        lastTrigger.focus();
      }
    }

    function openModal(trigger) {
      const embedSrc = normalizeEmbedSrc(
        trigger.getAttribute('data-video-url'),
        trigger.getAttribute('data-youtube-id'),
        trigger.getAttribute('data-video-provider'),
      );
      const videoTitle = trigger.getAttribute('data-video-title') || '';

      if (!embedSrc) return;

      lastTrigger = trigger;
      title.textContent = videoTitle;
      iframe.title = videoTitle;
      iframe.src = `${embedSrc}${embedSrc.includes('?') ? '&' : '?'}autoplay=1&rel=0&modestbranding=1`;
      modal.hidden = false;
      document.body.classList.add('arb-project-video-modal-open');

      /* The panel's close button, NOT the first [data-arb-project-video-close] in
         the modal — that is the full-viewport backdrop, which sits OUTSIDE the
         [aria-modal] panel, so a bare querySelector landed the opening focus on an
         element a modal-aware screen reader cannot reach. */
      const closeButton =
        modal.querySelector('[role="dialog"] [data-arb-project-video-close]')
        || modal.querySelector('[data-arb-project-video-close]');
      if (closeButton instanceof HTMLElement) closeButton.focus();
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        openModal(trigger);
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    /* The Tab handler alone cannot hold this dialog, and the reason is the
       player. Once focus is inside the cross-origin YouTube iframe, keydown
       fires in ITS document — the parent never sees it — so the browser walks
       focus straight out of the iframe into the page behind (measured: one leak
       to a footer social link). focusin DOES fire on the parent the moment focus
       lands on a parent-document element, so it is the only place that exit can
       be caught. Guarded on !modal.hidden, and on the target being outside the
       modal, so it never fights closeModal()'s own focus restore. */
    document.addEventListener('focusin', (event) => {
      if (modal.hidden) return;
      if (event.target instanceof Node && modal.contains(event.target)) return;
      const closeButton = modal.querySelector('[role="dialog"] [data-arb-project-video-close]');
      if (closeButton instanceof HTMLElement) closeButton.focus();
    });

    /* DOCUMENT-level, matching the gallery's reasoning: a handler bound to the
       modal only fires while focus is already inside it, so anything that parks
       focus on <body> (a backdrop click, the iframe load) kills the trap. Guarded
       on !modal.hidden so it costs nothing while closed. */
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key === 'Tab') trapModalTab(modal, event);
    });
  }

  function initAll(container = document) {
    container.querySelectorAll(rootSelector).forEach(initProjectsGrid);
    initBasicFilterSetupMultiMatch(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
